import environmentVariables from './utils/get-environment-variables';

const apiContextPath = environmentVariables.REACT_APP_RUNTIME_API_URL;

export default {
  development: {
    apiContextPath,
  },
  production: {
    apiContextPath,
  },
// eslint-disable-next-line no-undef
}[process.env.NODE_ENV || 'development'];